// client/src/api/services/flutterwaveService.ts
import { apiClient } from '../client';
import { ENDPOINTS } from '../endpoints';
import { getErrorMessage } from '@/utils/errorUtils';
import { AxiosError } from "axios";

export interface FlutterwaveInitializePayload {
  amount: number;
  currency: string;
  phone: string;
  meta?: Record<string, unknown> | Array<Record<string, unknown>>;
}


export interface FlutterwaveInitializeResponse {
  success: boolean;
  message: string;
  data: {
    transactionId: string;
    paymentLink: string;
    txRef: string;
    amount: number;
    currency: string;
    status: string;
  };
}

export interface FlutterwaveVerifyParams {
  status: string;
  tx_ref: string;
  transaction_id: string | number;
}

export interface FlutterwaveVerifyResponse {
  success?: boolean;
  message?: string;
  data?: unknown;
}

export const initializeFlutterwave = async (
  payload: FlutterwaveInitializePayload
): Promise<FlutterwaveInitializeResponse> => {
  try {
    const response = await apiClient.post<FlutterwaveInitializeResponse>(
      ENDPOINTS.FLUTTERWAVE.INITIALIZE,
      payload
    );
    return response.data;
  } catch (error: unknown) {
    console.error('Error initializing Flutterwave:', error);
    throw new Error(
      getErrorMessage(error) || 'Failed to initialize Flutterwave'
    );
  }
};

export const verifyFlutterwave = async (
  params: FlutterwaveVerifyParams
): Promise<FlutterwaveVerifyResponse> => {
  try {
    const response = await apiClient.get<FlutterwaveVerifyResponse>(
      ENDPOINTS.FLUTTERWAVE.VERIFY,
      { params }
    );
    return response.data;
  } catch (error: unknown) {
    console.error('Error verifying Flutterwave:', error);
    throw new Error(
      getErrorMessage(error) || 'Failed to verify Flutterwave payment'
    );
  }
};

export default {
  initializeFlutterwave,
  verifyFlutterwave,
};
